<template>
  <transition name="fade">
    <v-app key="app-1" id="app">
      <HeaderSign
        v-if="$route.name === 'linkProjectReportSign' && localStorage.translations.pages"
      />
      <template v-if="checkRequiredData">
        <Header
          v-if="
            isLoggedIn &&
            this.noFirstLogin &&
            $cookies.get('languageSelect') &&
            localStorage.translations.pages &&
            $route.name !== 'linkProjectReportSign'
          "
          id="header"
        />
        <transition name="slide-fade" mode="out-in" appear>
          <router-view v-if="defaultCheck"/>
        </transition>
        <ProAppIntelligence v-if="showProAppIntelligence" />
        <UpButton/>
        <Footer v-if="defaultCheck"/>
      </template>
      <Greeting v-if="defaultCheck"/>
      <BanModal/>
      <LanguagesChangeModal/>
      <transition name="fade">
        <LoadingAnimation fullPage v-if="!checkRequiredData || loadingAnimationFullPage"/>
      </transition>
      <transition name="fade">
        <PdfLoader/>
      </transition>
      <OfferAgreementUserShowModal/>
      <ModalSaveChange v-if="defaultCheck"/>
      <div id="checkDiv" class="container"></div>
    </v-app>
  </transition>
</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import SocketioChatService from '~/services/socketio/socketio.chat.service.js'

import axios from 'axios'

import Header from 'components/header/Header'
import HeaderSign from 'components/HeaderSign'
import Footer from 'components/Footer'
import Greeting from 'components/Greeting'
import UpButton from 'components/UpButton'
import LanguagesChangeModal from 'components/setting/languages/LanguagesChangeModal'
import OfferAgreementUserShowModal from 'components/setting/offerAgreement/OfferAgreementUserShowModal'
import BanModal from 'components/BanModal'
import LoadingAnimation from 'components/LoadingAnimation'
import ModalSaveChange from 'components/ModalSaveChange'
import PdfLoader from 'components/pdf/pdfLoader.vue'
import ProAppIntelligence from 'components/proAppIntelligence/ProAppIntelligence'

const isMobile = navigator.userAgent.match(/Android|Tablet|iPhone|iPad|iPod/i)

export default {
  name: 'App',
  components: {
    PdfLoader,
    Header,
    HeaderSign,
    Footer,
    Greeting,
    BanModal,
    LanguagesChangeModal,
    OfferAgreementUserShowModal,
    UpButton,
    LoadingAnimation,
    ModalSaveChange,
    ProAppIntelligence,
  },
  data() {
    return {
      isMobileDevice: false,
    }
  },

  // beforeCreate() {
  //   this.$vuetify.theme.themes.light.primary = {
  //     base: '#277faf',
  //     lighten5: '#BEDBEB',
  //     lighten4: '#A3EBFF',
  //     lighten3: '#86CFFF',
  //     lighten2: '#69B4E7',
  //     lighten1: '#4A99CB',
  //     darken1: '#006694',
  //     darken2: '#16558F',
  //     darken3: '#003761',
  //     darken4: '#002249',
  //   }
  //   this.$vuetify.theme.themes.light.grey = {
  //     base: '#9e9e9e',
  //     lighten5: '#fafafa',
  //     lighten4: '#f5f5f5',
  //     lighten3: '#eeeeee',
  //     lighten2: '#ebeff2',
  //     lighten1: '#bdbdbd',
  //     darken1: '#757575',
  //     darken2: '#616161',
  //     darken3: '#424242',
  //     darken4: '#2c2c2c',
  //   }
  // },

  created() {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.toJSON().message === 'Network Error') {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['network_error'],
              IsError: true,
            },
            {root: true},
          )
        } else if (error.response.status == 401) {
          this.logout()
        } else if (error.response.status == 402) {
          this.$store.commit('offerAgreement/setOfferAgreementNotAccepted', true)
        } else if (error.response.status == 403) {
          this.$router.push({name: 'Home'})
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['not_enough_rights'],
              IsError: true,
            },
            {root: true},
          )
        } else if (error.response.status == 404) {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['oshibka'] + ' ' + 404,
              IsError: true,
            },
            {root: true},
          )
        } else if (error.response.status == 429) {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['too_many_requests'],
              IsError: true,
            },
            {root: true},
          )
        } else if (error.response.status == 500) {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['oshibka'] +
                ' ' +
                500 +
                '\n' +
                'Internal Server Error',
              IsError: true,
            },
            {root: true},
          )
        }

        throw error
      },
    )

    this.onCompaniesConfig()
    this.onLanguages()
    this.userData()
    // this.$axios.interceptors.response.use(undefined, function(err) {
    //     return new Promise(() => {
    //         if (
    //             err.status === 401 &&
    //             err.config &&
    //             !err.config.__isRetryRequest
    //         ) {
    //             this.$store.dispatch('logout')
    //         }
    //         throw err
    //     })
    // })
    this.updateRules()

    if (process.browser) {
      window.addEventListener('resize', this.checkAll)
      this.checkAll()
    }
    this.onCheckTranslation()
  },

  updated() {
    this.checkAll()
  },
  mounted() {
    this.onFirebaseInit({login: false})
  },
  computed: {
    ...mapState(['useProtocol', 'pathAfterAuth', 'configData']),
    ...mapState('chat/auth', ['chatAuth_token']),
    ...mapGetters('auth', ['isLoggedIn', 'authToken']),
    ...mapGetters('translations', ['translationsLastUpdate']),
    ...mapGetters('user', ['userType', 'userRoleAbilities']),
    ...mapGetters(['loadingAnimationFullPage', 'apiDomain']),
    showMessage() {
      return this.$store.getters['popup/showMessage']
    },
    noFirstLogin() {
      return this.$store.getters['user/noFirstLogin']
    },
    checkRequiredData() {
      return this.isLoggedIn
        ? this.userType !== undefined && this.userRoleAbilities !== undefined
        : true
    },
    appVersion() {
      return process.env.VUE_APP_VERSION
    },
    defaultCheck() {
      return this.$cookies.get('languageSelect') && this.localStorage.translations.pages
    },
    showProAppIntelligence() {
      const excludedRoutes = [
        'Login',
        'ConfirmEmail',
        'ConfirmRestore',
        'FirstAuth',
        'Mobile',
        'linkProjectReportSign',
      ]
      const authenticatedRoute = this.$route.matched.some((route) => route.meta.requiresAuth)

      return Boolean(
        this.isLoggedIn &&
          this.noFirstLogin &&
          this.defaultCheck &&
          authenticatedRoute &&
          !excludedRoutes.includes(this.$route.name),
      )
    },
  },
  watch: {
    isLoggedIn() {
      this.userData()
    },
    $route: {
      handler() {
        this.STOP_record()
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('userInterface', ['onUserInterfacePage']),
    ...mapActions('translations', ['onTranslationsAllPage', 'onTranslationsLastUpdate']),
    ...mapActions(['onCompaniesConfig']),
    ...mapActions('languages', ['onLanguages']),
    ...mapActions('firebase', ['onFirebaseInit']),
    ...mapActions('record', ['STOP_record']),
    ...mapMutations(['setInputRules']),
    async userData() {
      if (this.isLoggedIn) {
        await this.$store.dispatch('user/getUser').then(() => {
          this.checkUserAccess()
          SocketioChatService.setupSocketConnection()
        })
      }
    },
    onCheckTranslation() {
      if ($cookies.get('languageSelect')) {
        if (
          !this.localStorage.translations ||
          this.localStorage.translations.language_id !== $cookies.get('languageSelect').id
        ) {
          this.onTranslationsAllPage({
            language_id: $cookies.get('languageSelect').id,
            storage: this.localStorage,
            type: 'web',
          })
        } else {
          this.onTranslationsLastUpdate({
            language_id: $cookies.get('languageSelect').id,
            type: 'web',
          }).then((resp) => {
            if (resp !== this.localStorage.translations.last_update) {
              this.onTranslationsAllPage({
                language_id: $cookies.get('languageSelect').id,
                storage: this.localStorage,
                type: 'web',
              })
            }
          })
        }
        if (
          !this.localStorage.mobile ||
          this.localStorage.mobile.language_id !== $cookies.get('languageSelect').id
        ) {
          this.onTranslationsAllPage({
            language_id: $cookies.get('languageSelect').id,
            storage: this.localStorage,
            type: 'mobile',
          })
        } else {
          this.onTranslationsLastUpdate({
            language_id: $cookies.get('languageSelect').id,
            type: 'mobile',
          }).then((resp) => {
            if (resp !== this.localStorage.mobile.last_update) {
              this.onTranslationsAllPage({
                language_id: $cookies.get('languageSelect').id,
                storage: this.localStorage,
                type: 'mobile',
              })
            }
          })
        }
      }
    },
    async checkUserAccess() {
      const onError = () => {
        this.$router.push({name: 'Home'}).catch(() => {
        })
        this.$store.dispatch(
          'popup/onMessage',
          {
            message:
              this.localStorage.translations.pages.common.notifications['not_permission_view_page'],
            IsError: true,
          },
          {root: true},
        )
      }
      if (this.userType !== 'superadmin') {
        this.$router.currentRoute.matched.some((route) => {
          if (route.meta.access) {
            if (route.meta.access.userType && route.meta.access.abilities) {
              if (route.meta.access.userType !== this.userType) {
                onError()
              } else if (!this.$userCheckAccess({abilities: route.meta.access.abilities})) {
                onError()
              }
            } else if (!route.meta.access.userType && route.meta.access.abilities) {
              if (!this.$userCheckAccess({abilities: route.meta.access.abilities})) onError()
            } else if (route.meta.access.userType && !route.meta.access.abilities) {
              if (route.meta.access.userType !== this.userType) onError()
            }
          }
        })
      }
    },
    async checkAll() {
      await this.updateWidth()
      if (!this.isLoggedIn) {
        if (
          this.$route.name !== 'ConfirmEmail' &&
          this.$route.name !== 'ConfirmRestore' &&
          this.$route.name !== 'linkProjectReportSign'
        ) {
          this.$router.replace({name: 'Login'}).catch(() => {
          })
        }
      } else if (!this.isLoggedIn && this.$route.name === 'Home') {
        this.$router.push({name: 'Login'}).catch(() => {
        })
      } else {
        if (!this.noFirstLogin) {
          this.$router.push({name: 'FirstAuth'}).catch(() => {
          })
        } else {
          if (
            this.$route.name === 'Login' ||
            this.$route.name === 'ConfirmEmail' ||
            this.$route.name === 'ConfirmRestore' ||
            this.$route.name === 'FirstAuth'
          ) {
            this.$router
              .push(this.pathAfterAuth ? {path: this.pathAfterAuth} : {name: 'Home'})
              .then(() => {
                if (this.pathAfterAuth) this.$store.state.pathAfterAuth = null
              })
              .catch(() => {
              })
          }
          if (!this.isMobileDevice) {
            if (this.$route.name === 'Mobile') {
              this.$router.go(-1).catch(() => {
                this.$router.push({name: 'Home'})
              })
            }
          } else {
            if (this.$route.fullPath !== '/' && !this.$route.meta.responsive) {
              this.$router.push({name: 'Mobile'}).catch(() => {
              })
            }
          }
        }
      }
    },
    updateWidth() {
      if (process.browser) {
        if (window.innerWidth <= 999) {
          this.isMobileDevice = true
        } else {
          this.isMobileDevice = false
        }
      }
    },
    updateRules() {
      if (
        this.localStorage.translations &&
        this.localStorage.translations.pages &&
        this.localStorage.translations.pages.common
      ) {
        let data = {
          required: (v) =>
            Array.isArray(v)
              ? !!v && !!v.length
              : (typeof v === 'number' ? v >= 0 : !!v) ||
              this.localStorage.translations.pages.common.rules.obyazatelno,
          requiredTime: (v) =>
            (!!v && v !== '00:00') || this.localStorage.translations.pages.common.rules.obyazatelno,
          requiredArray: (v) =>
            (v && !!v.length) || this.localStorage.translations.pages.common.rules.obyazatelno,
          size9: (v) =>
            !v ||
            (v && v.length === 9) ||
            this.localStorage.translations.pages.common.rules['size9'],
          size10: (v) =>
            (v && v.length === 10) ||
            this.localStorage.translations.pages.common.rules['dolzhno-byt-rovno-10-simvolov'],
          size5: (v) =>
            (v && v.length === 5) ||
            this.localStorage.translations.pages.common.rules['dolzhno-byt-rovno-5-simvolov'],
          max20: (v) =>
            v != null || v != undefined
              ? v.length <= 20 ||
              this.localStorage.translations.pages.common.rules['dolzhno-byt-menshe-20-simvolov']
              : true,
          max50: (v) =>
            v != null || v != undefined
              ? v.length <= 50 ||
              this.localStorage.translations.pages.common.rules['dolzhno-byt-menshe-50-simvolov']
              : true,
          max100: (v) =>
            v != null || v != undefined
              ? v.length <= 100 ||
              this.localStorage.translations.pages.common.rules['dolzhno-byt-menshe-100-simvolov']
              : true,
          max250: (v) =>
            v != null || v != undefined
              ? v.length <= 250 || 'Превышен лимит в 250 символов в строке'
              : true,
          min6: (v) =>
            (v && v.length >= 6) || this.localStorage.translations.pages.common.rules['min6'],
          email: (v) =>
            /.+@.+\..+/.test(v) || this.localStorage.translations.pages.common.rules['email'],
          phoneCountry: (v) =>
            this.phoneInput.valid ||
            this.localStorage.translations.pages.common.rules['phone_country'],
        }
        this.setInputRules(data)
      }
    },
  },
  beforeResolve(to, from, next) {
    if (to.name) {
      this.loading = true
    }
    next()
  },
  beforeUnmount() {
    SocketioChatService.disconnect()
  },
  afterEach() {
    // Complete the animation of the route progress bar.
    this.loading = false
  },
}
</script>

<style lang="scss">
@import 'scss/main.scss';

#app {
  background-color: var(--v-secondary-lighten4);
  color: var(--v-secondary-darken4);
}
</style>
